import type { Theme } from '@soteria/design-system-ve';

import type { SettingsDialogState, ThemeState } from './types';

/**
 * Initial settings dialog state
 */
export const initialSettingsDialogState: SettingsDialogState = {
  isSettingsDialogOpen: false,
};

/**
 * Initial theme state
 */
export const initialThemeState: ThemeState = {
  theme: 'system',
  isHighContrast: false,
  completeTheme: {} as Theme,
};
